import log from 'salvo-lite/log'

class Quantity {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._data = JSON.parse(this._elem.getAttribute('data-quantity'))
        this._event = this._data.event || 'click'
        this._inputField = this._data.inputField || elem.parentNode.querySelector('input[type="number"]')
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        this._elem.addEventListener(this._event, e => {
            if (this._data.action === 'increase') {
                this._inputField.value = parseInt(this._inputField.value) + 1
            } else if (this._data.action === 'decrease') {
                this._inputField.value = parseInt(this._inputField.value) - 1
            }

            let newEvent = false
            if (!newEvent) {
                // dispatch change event
                const changeEvent = new Event('change')
                this._inputField.dispatchEvent(changeEvent)
                newEvent = true
            }

            this.checkMinMax()
        })
    }

    checkMinMax () {
        if (parseInt(this._inputField.value) < this._inputField.min) {
            this._inputField.value = this._inputField.min
        } else if (this._inputField.max && parseInt(this._inputField.value) > this._inputField.max) {
            this._inputField.value = this._inputField.max
        }
    }
}

export default Quantity



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Quantity.js